import text from './firo-origins.txt';

const sections=new Map([
 ['We launched as Zcoin','Research and origins'],
 ['Most people shouldn','Privacy in practice'],
 ['When I think about why','The people behind Firo'],
 ['One of the harder lessons','More routes to market'],
 ['Our research is continuing','Looking ahead']
]);
const element=(tag,className,value)=>{const el=document.createElement(tag);if(className)el.className=className;if(value)el.textContent=value;return el;};

// The supplied article uses paragraphs and inline Markdown links only. Build DOM
// nodes rather than interpreting its contents as executable HTML.
function paragraph(line){
 const p=element('p');let end=0;
 for(const match of line.matchAll(/\[([^\]]*)\]\((https?:\/\/[^\s)]+)\)/g)){
  p.append(document.createTextNode(line.slice(end,match.index)));
  const a=element('a',match[1].trim()?'':'origins-source',match[1].trim()||'Source');
  a.href=match[2];a.target='_blank';a.rel='noopener noreferrer';
  if(!match[1].trim())a.setAttribute('aria-label',`Source: ${new URL(match[2]).hostname}`);
  p.append(a);end=match.index+match[0].length;
 }
 p.append(document.createTextNode(line.slice(end)));return p;
}

let reader;
export function openOrigins(){
 if(!reader){
  const lines=text.split(/\r?\n/).map(line=>line.trim()).filter(Boolean);
  reader=element('dialog','origins-reader');reader.setAttribute('aria-labelledby','origins-title');
  const header=element('header','origins-header');
  const heading=element('div');heading.append(element('p','origins-eyebrow','FROM THE JOURNAL'));
  const title=element('h1',null,'Firo Zine');title.id='origins-title';heading.append(title);
  heading.append(element('p','origins-byline',lines.shift()));
  const close=element('button','icon-button origins-close');close.type='button';close.setAttribute('aria-label','Close Firo Zine');close.title='Close';
  const icon=element('i');icon.dataset.lucide='x';close.append(icon);close.addEventListener('click',()=>reader.close());header.append(heading,close);
  const body=element('div','origins-body');
  const nav=element('nav','origins-contents');nav.setAttribute('aria-label','Article sections');
  const article=element('article','origins-article');let index=0;
  for(const line of lines){
   const section=[...sections].find(([prefix])=>line.startsWith(prefix));
   if(section){
    const h=element('h2',null,section[1]);h.id=`origins-section-${++index}`;h.tabIndex=-1;article.append(h);
    const link=element('a',null,section[1]);link.href=`#${h.id}`;
    link.addEventListener('click',event=>{event.preventDefault();h.scrollIntoView({block:'start'});h.focus({preventScroll:true});});nav.append(link);
   }
   article.append(paragraph(line));
  }
  body.append(nav,article);reader.append(header,body);document.body.append(reader);
  reader.addEventListener('click',event=>{if(event.target!==reader)return;const r=reader.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)reader.close();});
 }
 reader.showModal();reader.querySelector('.origins-body').scrollTop=0;
}
